<template>
  <div>
    <ManageLoyalty />
  </div>
</template>
<script>
import ManageLoyalty from "@/components/Loyalty/ManageLoyalty";
export default {
  components: {
    ManageLoyalty,
  },
  created() {},
};
</script>
